var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.12227V16.4988C13.5 17.3285 12.8297 17.9988 12 17.9988C11.1703 17.9988 10.5 17.3285 10.5 16.4988V5.12227L7.05938 8.56289C6.47344 9.14883 5.52188 9.14883 4.93594 8.56289C4.35 7.97695 4.35 7.02539 4.93594 6.43945L10.9359 0.439453C11.5219 -0.146484 12.4734 -0.146484 13.0594 0.439453L19.0594 6.43945C19.6453 7.02539 19.6453 7.97695 19.0594 8.56289C18.4734 9.14883 17.5219 9.14883 16.9359 8.56289L13.5 5.12227ZM3 16.4988H9C9 18.1535 10.3453 19.4988 12 19.4988C13.6547 19.4988 15 18.1535 15 16.4988H21C22.6547 16.4988 24 17.8441 24 19.4988V20.9988C24 22.6535 22.6547 23.9988 21 23.9988H3C1.34531 23.9988 0 22.6535 0 20.9988V19.4988C0 17.8441 1.34531 16.4988 3 16.4988ZM20.25 21.3738C20.5484 21.3738 20.8345 21.2553 21.0455 21.0443C21.2565 20.8333 21.375 20.5472 21.375 20.2488C21.375 19.9505 21.2565 19.6643 21.0455 19.4533C20.8345 19.2424 20.5484 19.1238 20.25 19.1238C19.9516 19.1238 19.6655 19.2424 19.4545 19.4533C19.2435 19.6643 19.125 19.9505 19.125 20.2488C19.125 20.5472 19.2435 20.8333 19.4545 21.0443C19.6655 21.2553 19.9516 21.3738 20.25 21.3738Z",
    fill: "#3582D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.829d268f849f63546f15e1f805f10f3f.svg";
export { ForwardRef as ReactComponent };